import React, { useState } from 'react';
import DocumentCheckSC from './document-check.styled';
import { ReactComponent as PdfIcon } from '../../../assets/img/svg/pdf.svg';
import PropTypes from 'prop-types';
import SmallText from '../../typography/small-text';

const DocumentCheck = ({ onClick, title }) => {
  const [isActive, setActive] = useState(false);

  const makeOnClickAction = () => {
    setActive(true);
    onClick();
  };

  return (
    <DocumentCheckSC>
      <div className={isActive ? 'status-box active' : 'status-box'}></div>
      <button onClick={() => makeOnClickAction()}>
        <PdfIcon /> <SmallText>{title}</SmallText>
      </button>
    </DocumentCheckSC>
  );
};

DocumentCheck.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
};

DocumentCheck.defaultProps = {
  onClick: () => {},
  title: '',
};

export default DocumentCheck;
